<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-id.mr-2(ref="nric" :filter.sync="idFilter" check-initial-value)
    filter-phone.mr-2(ref="phone" :filter.sync="phoneFilter" check-initial-value)
    filter-email.mr-2(ref="email" :filter.sync="emailFilter" check-initial-value)
    filter-age.mr-2(ref="age" :filter.sync="ageFilter" check-initial-value)
    filter-gender.mr-2(ref="gender" :filter.sync="genderFilter" check-initial-value)
    filter-nationality.mr-2(ref="nationality" :filter.sync="nationalityFilter" check-initial-value)
    filter-race.mr-2(ref="race" :filter.sync="raceFilter" check-initial-value)
    filter-religion.mr-2(ref="religion" :filter.sync="religionFilter" check-initial-value)
    filter-lifetime-value.mr-2(ref="spent" :filter.sync="lifetimeValueFilter" check-initial-value)
    filter-total-visit.mr-2(ref="visit" :filter.sync="totalVisitFilter" check-initial-value)
    filter-medications.mr-2(ref="medication" :filter.sync="medicationFilter" check-initial-value)
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterId from '@/components/clinic/patient/filters/FilterId.vue'
import FilterPhone from '@/components/clinic/patient/filters/FilterPhone.vue'
import FilterEmail from '@/components/clinic/patient/filters/FilterEmail.vue'
import FilterAge from '@/components/module/filter/FilterAge.vue'
import FilterGender from '@/components/clinic/patient/filters/FilterGender.vue'
import FilterNationality from '@/components/clinic/patient/filters/FilterNationality.vue'
import FilterRace from '@/components/clinic/patient/filters/FilterRace.vue'
import FilterReligion from '@/components/clinic/patient/filters/FilterReligion.vue'
import FilterLifetimeValue from '@/components/clinic/patient/filters/FilterLifetimeValue.vue'
import FilterTotalVisit from '@/components/clinic/patient/filters/FilterTotalVisit.vue'
import FilterMedications from '@/components/clinic/patient/filters/FilterMedications.vue'

export default {
  components: {
    FilterName, FilterId, FilterPhone, FilterEmail, FilterAge, FilterGender, FilterNationality,
    FilterRace, FilterReligion, FilterLifetimeValue, FilterTotalVisit, FilterMedications
  },
  props: ['filters', 'propFilters'],
  data: () => ({
    key: 0,
    nameFilter: {},
    idFilter: {},
    phoneFilter: {},
    emailFilter: {},
    ageFilter: {},
    genderFilter: {},
    nationalityFilter: {},
    raceFilter: {},
    religionFilter: {},
    lifetimeValueFilter: {},
    totalVisitFilter: {},
    medicationFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.idFilter.key) {
        filters.push(this.idFilter)
      }
      if (this.phoneFilter.key) {
        filters.push(this.phoneFilter)
      }
      if (this.emailFilter.key) {
        filters.push(this.emailFilter)
      }
      if (this.ageFilter.key) {
        if (this.ageFilter.key === 'between') {
          const values = this.ageFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.ageFilter)
        }
      }
      if (this.genderFilter.key) {
        filters.push(this.genderFilter)
      }
      if (this.nationalityFilter.key) {
        filters.push(this.nationalityFilter)
      }
      if (this.raceFilter.key) {
        filters.push(this.raceFilter)
      }
      if (this.religionFilter.key) {
        filters.push(this.religionFilter)
      }
      if (this.lifetimeValueFilter.key) {
        if (this.lifetimeValueFilter.key === 'between') {
          const values = this.lifetimeValueFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.lifetimeValueFilter)
        }
      }
      if (this.totalVisitFilter.key) {
        if (this.totalVisitFilter.key === 'between') {
          const values = this.totalVisitFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.totalVisitFilter)
        }
      }
      if (this.medicationFilter.key) {
        filters.push(this.medicationFilter)
      }

      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        idFilter: this.idFilter,
        phoneFilter: this.phoneFilter,
        emailFilter: this.emailFilter,
        ageFilter: this.ageFilter,
        genderFilter: this.genderFilter,
        nationalityFilter: this.nationalityFilter,
        raceFilter: this.raceFilter,
        religionFilter: this.religionFilter,
        lifetimeValueFilter: this.lifetimeValueFilter,
        totalVisitFilter: this.totalVisitFilter,
        medicationFilter: this.medicationFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.idFilter = this.propFilters?.idFilter || {}
      this.phoneFilter = this.propFilters?.phoneFilter || {}
      this.emailFilter = this.propFilters?.emailFilter || {}
      this.ageFilter = this.propFilters?.ageFilter || {}
      this.genderFilter = this.propFilters?.genderFilter || {}
      this.nationalityFilter = this.propFilters?.nationalityFilter || {}
      this.raceFilter = this.propFilters?.raceFilter || {}
      this.religionFilter = this.propFilters?.religionFilter || {}
      this.lifetimeValueFilter = this.propFilters?.lifetimeValueFilter || {}
      this.totalVisitFilter = this.propFilters?.totalVisitFilter || {}
      this.medicationFilter = this.propFilters?.medicationFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.nric.setData()
        this.$refs.phone.setData()
        this.$refs.email.setData()
        this.$refs.age.setData()
        this.$refs.gender.setData()
        this.$refs.nationality.setData()
        this.$refs.race.setData()
        this.$refs.religion.setData()
        this.$refs.spent.setData()
        this.$refs.visit.setData()
        this.$refs.medication.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.idFilter = {}
      this.phoneFilter = {}
      this.emailFilter = {}
      this.ageFilter = {}
      this.genderFilter = {}
      this.nationalityFilter = {}
      this.raceFilter = {}
      this.religionFilter = {}
      this.lifetimeValueFilter = {}
      this.totalVisitFilter = {}
      this.medicationFilter = {}
    },
  }
}
</script>